import React, { useState, useEffect } from "react";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";
import BlogMainSection from "../../components/blogs/BlogsMainSection";
import BlogLoadMore from "../../components/blogs/BlogsLoadMore";
import Heading from "../../components/blogs/Heading";
import BlogPostCard from "../../components/blogs/BlogsPostCard";
import PageContent from "../../components/blogs/PageContent";
import SideBar from "../../components/blogs/SideBar";
import ComponentsLoader from "../../components/includes/ComponentsLoader";
import TopicLinks from "../../components/content/TopicLinks";
import { useBlogContext } from "../../shared/context/BlogContext";
import ButtonPrimary from "../../shared/components/Buttons Medium/ButtonPrimary";
import { useTranslation } from "react-i18next";

export default function Blogs() {
  const Lng = localStorage.getItem("lang");
  const [nbQuestions, setNbQuestions] = useState(0);
  const { t } = useTranslation();
  const [blogs, setBlogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [limit, setLimit] = useState(4);
  const [topics, setTopics] = useState([]);
  const { getBlogsByFilter, getBlogCategories } = useBlogContext();
  async function viewMore() {
    let res = await getBlogsByFilter({
      limit: limit + 4,
      filters: [{ language: Lng, status: "published" }],
    });
    setLimit(limit + 4);
    setBlogs(res.data?.blogs ?? []);
    setNbQuestions(limit);
  }
  useEffect(() => {
    async function fetchBlogs() {
      const response = await getBlogsByFilter({
        limit: 4,
        filters: [{ language: Lng, status: "published" }],
      });
      setBlogs(response.data?.blogs ?? []);
      setIsLoading(false);
    }
    fetchBlogs();
  }, [getBlogsByFilter]);
  // Topic pages with content in this language.
  useEffect(() => {
    let live = true;
    getBlogCategories({ language: currentLang() }).then((res) => {
      if (live) setTopics(res.data?.categories ?? []);
    });
    return () => {
      live = false;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <>
      <Heading />
      <PageContent>
        <Seo
          title={copy.blogs(currentLang()).title}
          description={copy.blogs(currentLang()).description}
          path={urls.sectionPath("blogs", currentLang())}
          alternates={urls.alternates((l) => urls.sectionPath("blogs", l))}
        />
        <BlogMainSection>
          <div className="col-12">
            <TopicLinks topics={topics} lang={currentLang()} />
          </div>
          {isLoading ? (
            <ComponentsLoader />
          ) : blogs?.length > 0 ? (
            blogs.map((blog) => {
              return <BlogPostCard key={blog._id || blog.id} blog={blog} />;
            })
          ) : null}
          {blogs.length > 0 && blogs.length >= nbQuestions && (
            <BlogLoadMore>
              <ButtonPrimary onclick={viewMore} value={t("Load_More")} />
            </BlogLoadMore>
          )}
        </BlogMainSection>
        <SideBar />
      </PageContent>
    </>
  );
}
